<template>
	<div >
		<div class="bottom" :style="'background-image:' + `url(${require('@/assets/img/news/bottom_back.png')})`">
			<div class="bottom_div">
				<div class="dt_div_left">
					<div>
						<a class="dt_div_left_title" @click="goAnchor('home')">{{$t('bottom.class1.title')}}</a>
						<a class="dt_div_left_title2" @click="goAnchor('home','#product')">{{$t('bottom.class1.text1')}}</a>
						<a class="dt_div_left_title2" @click="goAnchor('home','#about')">{{$t('bottom.class1.text2')}}</a>
						<!-- <a class="dt_div_left_title2" @click="goAnchor('home','#news')">{{$t('bottom.class1.text3')}}</a> -->
					</div>
					
					<div style="padding-left: 60px;">
						<a class="dt_div_left_title" @click="goAnchor('aboutUs')">{{$t('bottom.class2.title')}}</a>
						<a class="dt_div_left_title2" @click="goAnchor('aboutUs','#aboutUs')">{{$t('bottom.class2.text1')}}</a>
						<!-- <a class="dt_div_left_title2" @click="goAnchor('aboutUs','#developmentHistory')">{{$t('bottom.class2.text2')}}</a> -->
						<a class="dt_div_left_title2" @click="goAnchor('aboutUs','#qualificationsHonors')">{{$t('bottom.class2.text3')}}</a>
						<a class="dt_div_left_title2" @click="goAnchor('aboutUs','#coreConcepts')">{{$t('bottom.class2.text4')}}</a>
					</div>

					<div style="padding-left: 60px;">
						<a class="dt_div_left_title" @click="goAnchor('productCenter')">{{$t('bottom.class3.title')}}</a>
						<a class="dt_div_left_title2" v-for="(item,index) in $t('product.tabList')" :key="index" @click="goAnchor('productCenter',index)">{{item.name}}</a>
					</div>

					<!-- <div style="padding-left: 60px;">
						<a class="dt_div_left_title" @click="goAnchor('customer')">{{$t('bottom.class4.title')}}</a>
					</div>

					<div style="padding-left: 60px;">
						<a class="dt_div_left_title" @click="goAnchor('news')">{{$t('bottom.class5.title')}}</a>
					</div> -->

					<div style="padding-left: 60px;">
						<a class="dt_div_left_title" @click="goAnchor('contactUs')">{{$t('bottom.class6.title')}}</a>
					</div>
				</div>
				
				<div style="width: 15%;position: relative;display: flex;justify-content: right;">
					<el-image :lazy="true" style="width: 150px;height: 150px;" :src="aboutList.wechat_public"></el-image>		
				</div>
			</div>
			
			<!--  底部  -->
			<div style="text-align: center;padding-top: 20px;">
				 <!-- <a style="font-size: 10px;padding-left: 10px;color: #fff;" href="https://beian.miit.gov.cn/"></a> -->
				<span style="font-size: 10px;color: #fff;">{{$t('browerChange.bottomMark')}} </span>
			</div>
		</div>
	</div>
</template>

<script>
	import * as aboutApi from "@/api/home/about.js"
	import { scrollTo } from '@/utils/scroll-to'
	export default {
		data() {
			return {
				route:'',//route路由
				aboutList:{},//企业信息
			}
		},

		created() {
			this.route=this.$route.path;
			this.getAbout()
			// console.log(this.$route)
		},

		mounted() {

		},

		watch: {
			'$i18n.locale'(val) {
				this.getAbout()
			}
		},

		computed: {

		},

		methods: {
			//获取企业信息
			getAbout(){
				aboutApi.queryList({language:this.$i18n.locale == 'en'?'English':'中文'}).then(res=>{
					// console.log('关于企业信息1',res)
					if(res.code == 200 && res.rows.length>0){
					  let data = res.rows[0]
					  data.wechat_public = this.HttpChange('URL',data.wechat_public)
					  this.aboutList = data
					}
				})
			},
			//---------------锚点跳转----------------
			goAnchor: function(page,selector) {
				switch(page){
					case 'home':
					if(this.route != '/'){
						if(selector){
							this.$router.push({
								path: '/',
								query:{
									selector:selector
								}
							})
						}else{
							this.$router.push({
								path: '/',
							})
						}
					}else{
						if(selector){
							document.querySelector(selector).scrollIntoView({
								behavior: "smooth",
								block:'center'
							})
						}else{
							scrollTo(0,100)
						}
					}
					break;
					case 'aboutUs':
						if(this.route != '/aboutUs'){
							if(selector){
								this.$router.push({
									path: '/aboutUs',
									query:{
										selector:selector
									}
								})
							}else{
								this.$router.push({
									path: '/aboutUs',
								})
							}
						}else{
							if(selector){
								document.querySelector(selector).scrollIntoView({
									behavior: "smooth",
									block:'center'
								})
							}else{
								scrollTo(0,100)
							}
						}
					break;
					case 'productCenter':
						if(this.route != '/productCenter'){
							if(selector){
								this.$router.push({
									path: '/productCenter',
									query:{
										data:{index:selector,value:this.$t('product.tabList')[selector]}
									}
								})
							}else{
								this.$router.push({
									path: '/productCenter',
								})
							}
						}else{
							if(selector){
								this.$emit('bottomChange',{index:selector,value:this.$t('product.tabList')[selector]})
								document.querySelector('#subpageList').scrollIntoView({
									behavior: "smooth",
									block:'center'
								})
							}else{
								scrollTo(0,100)
							}
						}
					break;
					case 'customer':
						if(this.route != '/customer'){
							if(selector){
								this.$router.push({
									path: '/customer',
									query:{
										selector:selector
									}
								})
							}else{
								this.$router.push({
									path: '/customer',
								})
							}
						}else{
							if(selector){
								document.querySelector(selector).scrollIntoView({
									behavior: "smooth",
									block:'center'
								})
							}else{
								scrollTo(0,100)
							}
						}
					break;
					case 'news':
						if(this.route != '/news'){
							if(selector){
								this.$router.push({
									path: '/news',
									query:{
										selector:selector
									}
								})
							}else{
								this.$router.push({
									path: '/news',
								})
							}
						}else{
							if(selector){
								document.querySelector(selector).scrollIntoView({
									behavior: "smooth",
									block:'center'
								})
							}else{
								scrollTo(0,100)
							}
						}
					break;
					case 'contactUs':
						if(this.route != '/contactUs'){
							if(selector){
								this.$router.push({
									path: '/contactUs',
									query:{
										selector:selector
									}
								})
							}else{
								this.$router.push({
									path: '/contactUs',
								})
							}
						}else{
							if(selector){
								document.querySelector(selector).scrollIntoView({
									behavior: "smooth",
									block:'center'
								})
							}else{
								scrollTo(0,100)
							}
						}
					break;
				}
				
			}
		}
	}
</script>

<style lang="less" scoped>
	@media only screen and (min-width:1920px) {
		.btn {
			margin-top: 20px;
			width: 150px;
			line-height: 45px;
			height: 45px;
			border: 1px solid #fff;
			color: #fff;
			font-family: BigJohn;
			font-weight: bold;
			text-align: center;
			border-radius: 5px;
			user-select: none;
			cursor: pointer;
			position: relative;
			font-size: 16px;
			overflow: hidden;
		}
		
		.btn .learnMore {
			width: 100%;
			height: 100%;
			background: linear-gradient(to right, #621ed2, #3066f5);
			// background-repeat: no-repeat;
			left: -100%;
			position: absolute;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore {
			left: 0%;
			color: #fff;
			// z-index: 4;
		}
		
		.btn .learnMore2 {
			position: relative;
			transition: 0.6s;
			color: #fff;
		}
		
		.btn:hover {
			border: 1px solid #fff;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore2 {
			color: #fff;
			// z-index: 3;
		}
		
		.btn:active {
			box-shadow: 0 0 3px #ccc;
		}
		
		.bottom {
			padding: 80px 200px;
		
			.bottom_div {
				display: flex;
				width: 100%;
				position: relative;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				padding-bottom: 40px;
		
				.dt_div_left {
					width: 85%;
					display: flex;
		
					.dt_div_left_title {
						font-size: 18px;
						color: #fff;
						line-height: 32px;
						display: block;
						padding-bottom: 10px;
						position: relative;
						cursor: pointer;
					}
		
					.dt_div_left_title2 {
						font-size: 14px;
						line-height: 30px;
						color: #ccc;
						display: block;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	@media only screen and (max-width:1920px) {
		.btn {
			margin-top: 20px;
			width: 150px;
			line-height: 45px;
			height: 45px;
			border: 1px solid #fff;
			color: #fff;
			font-family: BigJohn;
			font-weight: bold;
			text-align: center;
			border-radius: 5px;
			user-select: none;
			cursor: pointer;
			position: relative;
			font-size: 16px;
			overflow: hidden;
		}
		
		.btn .learnMore {
			width: 100%;
			height: 100%;
			background: linear-gradient(to right, #621ed2, #3066f5);
			// background-repeat: no-repeat;
			left: -100%;
			position: absolute;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore {
			left: 0%;
			color: #fff;
			// z-index: 4;
		}
		
		.btn .learnMore2 {
			position: relative;
			transition: 0.6s;
			color: #fff;
		}
		
		.btn:hover {
			border: 1px solid #fff;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore2 {
			color: #fff;
			// z-index: 3;
		}
		
		.btn:active {
			box-shadow: 0 0 3px #ccc;
		}
		
		.bottom {
			padding: 80px 200px;
		
			.bottom_div {
				display: flex;
				width: 100%;
				position: relative;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				padding-bottom: 40px;
		
				.dt_div_left {
					width: 85%;
					display: flex;
		
					.dt_div_left_title {
						font-size: 18px;
						color: #fff;
						line-height: 32px;
						display: block;
						padding-bottom: 10px;
						position: relative;
						cursor: pointer;
					}
		
					.dt_div_left_title2 {
						font-size: 14px;
						line-height: 30px;
						color: #ccc;
						display: block;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	@media only screen and (max-width:1919px) and (min-width:1440px) {
		.btn {
			margin-top: 20px;
			width: 150px;
			line-height: 45px;
			height: 45px;
			border: 1px solid #fff;
			color: #fff;
			font-family: BigJohn;
			font-weight: bold;
			text-align: center;
			border-radius: 5px;
			user-select: none;
			cursor: pointer;
			position: relative;
			font-size: 16px;
			overflow: hidden;
		}
		
		.btn .learnMore {
			width: 100%;
			height: 100%;
			background: linear-gradient(to right, #621ed2, #3066f5);
			// background-repeat: no-repeat;
			left: -100%;
			position: absolute;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore {
			left: 0%;
			color: #fff;
			// z-index: 4;
		}
		
		.btn .learnMore2 {
			position: relative;
			transition: 0.6s;
			color: #fff;
		}
		
		.btn:hover {
			border: 1px solid #fff;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore2 {
			color: #fff;
			// z-index: 3;
		}
		
		.btn:active {
			box-shadow: 0 0 3px #ccc;
		}
		
		.bottom {
			padding: 80px 100px;
		
			.bottom_div {
				display: flex;
				width: 100%;
				position: relative;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				padding-bottom: 40px;
		
				.dt_div_left {
					width: 85%;
					display: flex;
		
					.dt_div_left_title {
						font-size: 18px;
						color: #fff;
						line-height: 32px;
						display: block;
						padding-bottom: 10px;
						position: relative;
						cursor: pointer;
					}
		
					.dt_div_left_title2 {
						font-size: 14px;
						line-height: 30px;
						color: #ccc;
						display: block;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	@media only screen and (max-width:1439px) and (min-width:1200px) {
		.btn {
			margin-top: 20px;
			width: 150px;
			line-height: 45px;
			height: 45px;
			border: 1px solid #fff;
			color: #fff;
			font-family: BigJohn;
			font-weight: bold;
			text-align: center;
			border-radius: 5px;
			user-select: none;
			cursor: pointer;
			position: relative;
			font-size: 16px;
			overflow: hidden;
		}
		
		.btn .learnMore {
			width: 100%;
			height: 100%;
			background: linear-gradient(to right, #621ed2, #3066f5);
			// background-repeat: no-repeat;
			left: -100%;
			position: absolute;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore {
			left: 0%;
			color: #fff;
			// z-index: 4;
		}
		
		.btn .learnMore2 {
			position: relative;
			transition: 0.6s;
			color: #fff;
		}
		
		.btn:hover {
			border: 1px solid #fff;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore2 {
			color: #fff;
			// z-index: 3;
		}
		
		.btn:active {
			box-shadow: 0 0 3px #ccc;
		}
		
		.bottom {
			padding: 80px 60px;
		
			.bottom_div {
				display: flex;
				width: 100%;
				position: relative;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				padding-bottom: 40px;
		
				.dt_div_left {
					width: 85%;
					display: flex;
		
					.dt_div_left_title {
						font-size: 18px;
						color: #fff;
						line-height: 32px;
						display: block;
						padding-bottom: 10px;
						position: relative;
						cursor: pointer;
					}
		
					.dt_div_left_title2 {
						font-size: 14px;
						line-height: 30px;
						color: #ccc;
						display: block;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	@media only screen and (max-width:1199px) and (min-width:768px) {
		.btn {
			margin-top: 20px;
			width: 150px;
			line-height: 45px;
			height: 45px;
			border: 1px solid #fff;
			color: #fff;
			font-family: BigJohn;
			font-weight: bold;
			text-align: center;
			border-radius: 5px;
			user-select: none;
			cursor: pointer;
			position: relative;
			font-size: 16px;
			overflow: hidden;
		}
		
		.btn .learnMore {
			width: 100%;
			height: 100%;
			background: linear-gradient(to right, #621ed2, #3066f5);
			// background-repeat: no-repeat;
			left: -100%;
			position: absolute;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore {
			left: 0%;
			color: #fff;
			// z-index: 4;
		}
		
		.btn .learnMore2 {
			position: relative;
			transition: 0.6s;
			color: #fff;
		}
		
		.btn:hover {
			border: 1px solid #fff;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore2 {
			color: #fff;
			// z-index: 3;
		}
		
		.btn:active {
			box-shadow: 0 0 3px #ccc;
		}
		
		.bottom {
			padding: 40px;
		
			.bottom_div {
				display: flex;
				width: 100%;
				position: relative;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				padding-bottom: 40px;
		
				.dt_div_left {
					width: 85%;
					display: flex;
		
					.dt_div_left_title {
						font-size: 18px;
						color: #fff;
						line-height: 32px;
						display: block;
						padding-bottom: 10px;
						position: relative;
						cursor: pointer;
					}
		
					.dt_div_left_title2 {
						font-size: 14px;
						line-height: 30px;
						color: #ccc;
						display: block;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	@media only screen and (max-width:767px) {
		.btn {
			margin-top: 20px;
			width: 150px;
			line-height: 45px;
			height: 45px;
			border: 1px solid #fff;
			color: #fff;
			font-family: BigJohn;
			font-weight: bold;
			text-align: center;
			border-radius: 5px;
			user-select: none;
			cursor: pointer;
			position: relative;
			font-size: 16px;
			overflow: hidden;
		}
		
		.btn .learnMore {
			width: 100%;
			height: 100%;
			background: linear-gradient(to right, #621ed2, #3066f5);
			// background-repeat: no-repeat;
			left: -100%;
			position: absolute;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore {
			left: 0%;
			color: #fff;
			// z-index: 4;
		}
		
		.btn .learnMore2 {
			position: relative;
			transition: 0.6s;
			color: #fff;
		}
		
		.btn:hover {
			border: 1px solid #fff;
			transition: 0.6s;
		}
		
		.btn:hover .learnMore2 {
			color: #fff;
			// z-index: 3;
		}
		
		.btn:active {
			box-shadow: 0 0 3px #ccc;
		}
		
		.bottom {
			padding: 20px;
		
			.bottom_div {
				display: flex;
				width: 100%;
				position: relative;
				border-bottom: 1px solid rgba(255, 255, 255, 0.1);
				padding-bottom: 40px;
		
				.dt_div_left {
					width: 85%;
					display: flex;
		
					.dt_div_left_title {
						font-size: 18px;
						color: #fff;
						line-height: 32px;
						display: block;
						padding-bottom: 10px;
						position: relative;
						cursor: pointer;
					}
		
					.dt_div_left_title2 {
						font-size: 14px;
						line-height: 30px;
						color: #ccc;
						display: block;
						cursor: pointer;
					}
				}
			}
		}
	}
	
	.el-login-footer {
		height: 40px;
		line-height: 40px;
		position: fixed;
		bottom: 0;
		width: 100%;
		text-align: center;
		color: #fff;
		font-family: Arial;
		font-size: 12px;
		letter-spacing: 1px;
	}
	
</style>
